"use client"

import { useState } from "react"
import { ChevronDown, List } from "lucide-react"
import { cn } from "@/lib/utils"

export function InlineToc({ items = [], defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen)

  if (items.length === 0) return null

  return (
    <nav className="rounded-lg border bg-muted/30">
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="flex w-full items-center justify-between px-4 py-3 sm:px-5"
      >
        <span className="flex items-center gap-2 text-sm font-semibold text-foreground">
          <List className="size-4 text-muted-foreground" />
          In this guide
        </span>
        <ChevronDown
          className={cn(
            "size-4 text-muted-foreground transition-transform duration-200",
            open && "rotate-180"
          )}
        />
      </button>

      {open && (
        <div className="border-t px-4 py-3 sm:px-5">
          <ol className="columns-1 gap-x-8 space-y-1 sm:columns-2">
            {items.filter((item) => item.depth === 2).map((item, i) => (
              <li key={item.id} className="break-inside-avoid">
                <a
                  href={`#${item.id}`}
                  className="flex items-start gap-2 rounded-md py-1 text-sm text-muted-foreground transition-colors hover:text-foreground"
                >
                  <span className="mt-px min-w-[1.25rem] text-xs font-medium text-muted-foreground/60">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  {item.label}
                </a>
              </li>
            ))}
          </ol>
        </div>
      )}
    </nav>
  )
}
